module.exports = __webpack_public_path__ + "img/hiking_1413_3.3435761c.jpg";